var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScientist3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1747,
    height: 922,
    viewBox: "0 0 1747 922",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58_9094",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1747,
    height: 921
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58_9094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1487.5,
    cy: 180.5,
    r: 610.5,
    fill: "black",
    fillOpacity: 0.29
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M889.86 305.854H857.738V341.845H889.86V305.854Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.244 291.921H841.096V313.98H902.244V291.921Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M940.945 330.622H803.557V697.506H940.945V330.622Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M856.964 475.363C876.628 475.363 892.568 459.422 892.568 439.758C892.568 420.094 876.628 404.153 856.964 404.153C837.3 404.153 821.359 420.094 821.359 439.758C821.359 459.422 837.3 475.363 856.964 475.363Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.67 790.775L953.59 711.825H771.695L709 790.775H1016.67Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.12 712.6H765.89C753.893 712.6 743.831 702.925 743.831 690.54V688.992H1036.8V690.54C1037.18 702.925 1027.12 712.6 1015.12 712.6Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.85 206.045L992.733 241.967L999.917 252.991L1055.04 217.069L1047.85 206.045Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.18 167.891L1027.62 201.488L1049.18 234.56L1100.73 200.963L1079.18 167.891Z",
    fill: "#D7D7D7",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M878.249 118.154H865.865V158.403H878.249V118.154Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M884.054 155.693H858.899V235.03H884.054V155.693Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M900.696 226.516H842.258V272.183H900.696V226.516Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M995.126 204.457L928.56 260.96L781.11 273.732L784.593 311.658L962.23 296.178L1022.6 251.285L995.126 204.457Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.31 747.817H242.26C231.078 747.817 221.928 738.667 221.928 727.485V521.115H266.15V727.485C265.642 738.667 256.493 747.817 245.31 747.817Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.421 604.474V725.449C221.421 737.648 231.079 747.306 243.278 747.306C255.477 747.306 265.135 737.648 265.135 725.449V603.966H221.421V604.474Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M273.268 514H213.797V555.681H273.268V514Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.181 747.817C316.982 747.817 307.324 738.159 307.324 725.96V521.115H351.546V725.451C351.546 737.651 341.38 747.817 329.181 747.817Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M307.324 604.474V725.449C307.324 737.648 316.982 747.306 329.181 747.306C341.38 747.306 351.038 737.648 351.038 725.449V603.966H307.324V604.474Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M359.17 514H299.699V555.681H359.17V514Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M415.083 747.817C402.884 747.817 393.226 738.159 393.226 725.96V521.115H437.448V725.451C437.448 737.651 427.282 747.817 415.083 747.817Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M393.226 604.474V725.449C393.226 737.648 402.883 747.306 415.083 747.306C427.282 747.306 436.939 737.648 436.939 725.449V603.966H393.226V604.474Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.564 514H385.094V555.681H444.564V514Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M500.985 747.817C488.786 747.817 479.128 738.159 479.128 725.96V521.115H523.35V725.451C523.35 737.651 513.184 747.817 500.985 747.817Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M479.128 604.474V725.449C479.128 737.648 488.786 747.306 500.985 747.306C513.184 747.306 522.842 737.648 522.842 725.449V603.966H479.128V604.474Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M530.467 514H470.996V555.681H530.467V514Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M568.081 578.046H183.807V591.262H568.081V727.486H165V759H594.513V751.376V727.486V591.262V578.046H568.081Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.9 153.878C1039.9 153.878 1038.65 190.035 1046.45 204.373C1054.24 218.711 1067.33 224.01 1068.26 236.166C1069.51 248.322 1063.9 264.53 1071.69 268.894C1079.49 273.258 1134.03 328.116 1151.49 326.869C1168.94 325.623 1187.64 300.687 1187.64 300.687L1226.92 325.934L1279.59 217.464L1244.68 185.671C1244.68 185.671 1230.35 100.266 1210.71 76.2655C1191.07 52.2648 1117.51 45.7192 1080.42 63.1742C1043.33 80.6292 1029.93 120.215 1021.2 127.695C1012.47 135.488 993.769 142.969 1003.74 157.307C1013.41 171.333 1039.9 153.878 1039.9 153.878Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.71 207.489C1238.76 204.372 1243.13 195.956 1246.55 187.229L1244.68 185.358C1244.68 185.358 1230.35 99.9536 1210.71 75.9529C1191.07 51.9523 1117.51 45.4067 1080.42 62.8617C1043.33 80.3167 1029.93 119.902 1021.2 127.383C1012.47 135.175 993.769 142.656 1003.74 156.994C1012.78 170.397 1036.47 156.059 1039.59 153.877L1039.9 153.565C1039.9 153.565 1057.36 147.955 1069.51 141.409C1081.67 134.864 1094.76 123.954 1094.76 123.954C1094.76 123.954 1071.69 162.293 1080.42 174.449C1089.15 186.605 1115.33 180.995 1115.33 180.995C1115.33 180.995 1132.79 204.06 1143.7 198.45C1154.6 192.839 1139.33 172.267 1155.85 164.475C1172.37 156.682 1185.46 189.722 1185.46 195.021C1185.46 200.943 1224.74 215.281 1234.71 207.489Z",
    fill: "black",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.55 187.541L1169.88 276.375C1169.88 276.375 1151.18 274.193 1138.08 264.219C1124.99 254.244 1114.08 230.244 1114.08 230.244C1114.08 230.244 1169.88 168.84 1198.55 151.385C1223.49 136.111 1231.59 133.306 1233.15 132.995C1232.22 129.254 1231.28 125.514 1230.03 121.773C1224.11 124.267 1206.66 133.306 1178.6 155.748C1148.06 180.684 1083.54 245.205 1067.33 261.413C1067.64 264.53 1068.89 267.024 1071.38 268.582C1079.17 272.946 1133.72 327.805 1151.18 326.558C1154.6 326.246 1158.03 325.311 1161.46 323.441C1164.89 309.726 1170.5 289.154 1175.18 280.427C1180.79 270.141 1237.2 209.048 1252.48 192.529L1246.55 187.541Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.31 202.191C1149.31 202.191 1139.33 167.281 1152.73 160.424C1165.83 153.878 1182.35 168.216 1184.53 183.489C1186.71 198.762 1178.92 217.464 1178.92 217.464C1178.92 217.464 1186.71 232.737 1183.28 249.257",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.31 202.191C1149.31 202.191 1139.33 167.281 1152.73 160.424C1165.83 153.878 1182.35 168.216 1184.53 183.489C1186.71 198.762 1178.92 217.464 1178.92 217.464C1178.92 217.464 1186.71 232.737 1183.28 249.257",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.89 229.308C1095.07 233.672 1095.07 237.724 1092.89 238.971C1090.71 240.218 1087.28 237.724 1085.1 233.361C1082.91 228.997 1082.91 224.945 1085.1 223.698C1087.28 222.451 1090.71 224.945 1092.89 229.308Z",
    fill: "#005D5F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.52 209.047C1064.52 209.047 1065.77 193.774 1084.16 196.891",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.41 204.684L1194.81 336.531L1227.23 360.22L1303.28 216.84L1277.41 204.684Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.67 219.334C1297.67 219.334 1233.77 329.986 1221.62 354.61C1209.46 379.234 1173.62 439.703 1171.12 475.549C1168.94 511.394 1142.5 918.5 1142.5 918.5L1419 921C1419 921 1434.2 561.888 1432.95 500.173C1431.7 438.768 1416.12 348.065 1369.05 286.349C1322.3 224.945 1297.67 219.334 1297.67 219.334Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.12 235.854C1320.12 235.854 1282.09 307.544 1256.22 348.688C1230.35 390.143 1196.99 434.716 1187.96 460.587C1178.92 486.458 1178.92 497.367 1178.92 497.367",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M990.028 517.937L959.794 495.495C959.794 495.495 945.144 458.715 936.416 448.429C927.377 438.455 915.221 440.637 907.429 431.598C899.636 422.558 890.597 402.61 886.233 400.428C881.869 398.246 871.583 403.857 871.583 412.584C871.583 421.623 881.558 435.961 881.558 439.39C881.558 442.819 881.558 442.819 881.558 442.819C881.558 442.819 843.531 431.598 839.167 435.026C834.803 438.455 830.128 449.676 833.556 455.287C836.985 460.897 843.531 463.079 843.531 467.443C843.531 471.806 835.738 486.456 840.102 492.067C844.466 497.677 851.323 501.106 851.323 501.106C851.323 501.106 851.323 522.301 858.181 531.34C865.038 540.38 916.468 546.925 932.053 549.107C947.637 551.289 993.457 573.731 993.457 573.731L990.028 517.937Z",
    fill: "#DCEEFF",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.45 325.622C1286.45 325.622 1238.45 348.999 1220.37 410.715C1202.61 472.119 1191.38 536.017 1191.38 536.017C1191.38 536.017 1180.16 533.835 1180.16 540.381C1180.16 547.238 1178.92 550.355 1178.92 550.355L984.418 513.575L980.054 605.214C980.054 605.214 1232.84 652.28 1246.24 652.28C1259.65 652.28 1274.3 647.916 1278.66 636.695C1283.02 625.474 1355.96 462.145 1355.96 462.145",
    fill: "#DFE33D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.45 325.622C1286.45 325.622 1238.45 348.999 1220.37 410.715C1202.61 472.119 1191.38 536.017 1191.38 536.017C1191.38 536.017 1180.16 533.835 1180.16 540.381C1180.16 547.238 1178.92 550.355 1178.92 550.355L984.418 513.575L980.054 605.214C980.054 605.214 1232.84 652.28 1246.24 652.28C1259.65 652.28 1274.3 647.916 1278.66 636.695C1283.02 625.474 1355.96 462.145 1355.96 462.145",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.89 377.052C1308.89 377.052 1346.92 398.247 1353.78 427.547",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.09 409.468C1285.52 409.468 1342.56 413.831 1354.71 446.248",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.45 508.9C1334.45 508.9 1378.09 488.639 1391.49 445.002",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 551.602C1189.2 551.602 1211.65 593.057 1210.4 622.045",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.61 544.744C1202.61 544.744 1225.05 549.108 1240.63 579.342",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist3);
export default __webpack_public_path__ + "static/media/scientist3.6de660997dafb76f442d75f451dca71b.svg";
export { ForwardRef as ReactComponent };